import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomButton } from 'components';
import { CaretRightIcon } from 'assets/icons';
import routesPath from 'routes/RoutesPath';
import { JobsRouteState } from 'routes/types';
import { JobListItem } from 'containers/jobs/jobs.model';
import JobsCard from './JobsCard';
import { resetCreateJobState } from 'containers/jobs/create-edit-job/createJobSlice';
import { useDispatch } from 'react-redux';

interface CustomerJobsWidgetProps {
  customerJobsList: JobListItem[];
  totalCustomerJobsCount: number;
  customerId: string;
}

const CustomerJobsWidget: React.FC<CustomerJobsWidgetProps> = ({
  customerJobsList,
  totalCustomerJobsCount,
  customerId
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleJobsNavigation = () => {
    const jobsRouteState: JobsRouteState = {
      customerId
    };
    navigate(routesPath.JOBS, { replace: false, state: { jobsFilters: jobsRouteState } });
  };

  return (
    <div className="mx-4 rounded-md border border-border">
      <div
        className="flex justify-between border-b border-borderGray
        px-4 py-3 text-sbase leading-[18px] tracking-[-0.3px]">
        <div className="font-bold text-primaryText">Upcoming Jobs</div>
        {totalCustomerJobsCount > 0 ? (
          <button className="font-semibold text-secondary" onClick={handleJobsNavigation}>
            See all
          </button>
        ) : (
          <></>
        )}
      </div>
      {customerJobsList?.length > 0 ? (
        <div className="flex flex-col gap-4 border-b border-borderGray p-4">
          {customerJobsList.map((job, index) => (
            <JobsCard job={job} key={index} />
          ))}
          <button
            className="flex justify-between text-sbase font-semibold
           leading-[18px] tracking-[-0.3px] text-secondary"
            onClick={handleJobsNavigation}>
            {totalCustomerJobsCount} job{totalCustomerJobsCount > 1 && 's'} to be started
            <CaretRightIcon className="path-fill-current text-gray-1" />
          </button>
        </div>
      ) : (
        <></>
      )}
      <div className="p-4">
        <CustomButton
          id="customer-details-create-job"
          className="h-10 w-full"
          childrenContainerStyles="text-17px font-semibold"
          onClick={() => {
            dispatch(resetCreateJobState());
            navigate('/jobs/create?customerId=' + customerId);
          }}>
          Create job
        </CustomButton>
      </div>
    </div>
  );
};

export default CustomerJobsWidget;
